import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid } from "@mui/material";

//import general components
import EmptyOrErrorState from "../../../common/empty-or-error-state/empty-or-error-state";

//import view components
import TourItem from "../tour-item/tour-item";

//import images and icons
import { InfoCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";

function TourList({ tourList }) {
    const { t } = useTranslation();
    const [list, setList] = useState([]);
    useEffect(() => {
        if (tourList) {
            setList(tourList?.results);
        } else {
            setList([]);
        }
    }, [tourList]);

    return (
        <Grid container item xs={12} rowGap={4} columnGap={4} justifyContent={{ xs: "center", md: "flex-start" }}>
            {list?.length ? (
                list?.map(tourItem => {
                    return (
                        <>
                            <Grid key={tourItem.id} container item md={3.7}>
                                <TourItem tourItem={tourItem} />
                            </Grid>
                        </>
                    );
                })
            ) : (
                <EmptyOrErrorState
                    title={t("Messages.No Tours Available")}
                    icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                />
            )}
        </Grid>
    );
}

export default connect(mapStateToProps)(TourList);

function mapStateToProps(state) {
    return {
        tourList: state.tourList,
    };
}
